import { createFileRoute } from '@tanstack/react-router';
import { CustomerSettingsPage } from '@/features/settings/customer-settings-page.js';

export const Route = createFileRoute('/_app/settings/customers')({
  component: CustomerSettingsPage,
});
